export default __webpack_public_path__ + "static/media/discord.7285f8be.png";